import { useContext } from 'react';
import useRangeUpdater from '@/srp/FiltersMenu/hooks/useRangeUpdater';
import RangeSlider from '@/srp/FiltersMenu/RangeSlider';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import TradeCard from './TradeCard';

type OwnProps = {
  isShowing: boolean;
};

export default function BudgetPrice({ isShowing }: OwnProps) {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();

  const onUpdate = useRangeUpdater({
    filterKey: 'price',
    max: facetData?.price?.max,
    min: facetData?.price?.min
  });

  return (
    <>
      <div className="flex-1 w-full">
        <RangeSlider
          dualRange
          isShowing={isShowing}
          id="price"
          label="Price Range"
          description="Vehicle price before taxes and shipping fees."
          format="dollars"
          labelTextTransform="uppercase"
          min={facetData?.price?.min}
          max={facetData?.price?.max}
          step={500}
          initialValues={[
            appliedFilters.price?.min ?? facetData.price?.min ?? 0,
            appliedFilters.price?.max ?? facetData.price?.max ?? 0
          ]}
          onUpdate={onUpdate}
        />
      </div>

      <div className="flex-1">
        <TradeCard />
      </div>
    </>
  );
}
